const MatchPage = () => {
  return (
    <div className='match'>
      比赛
    </div>
  )
}
export default MatchPage